export const BANCOS_CONFIG = [
  {
    banco: 'BRB',
    cor: '#003882',
    sigla: 'BRB',
    logo: 'img/logos/brb.jpeg',
    opcoes: [
      { label: 'Bonificada', valor: 11.34 },
      { label: 'Balcão', valor: 12 },
    ],
  },
  {
    banco: 'Bradesco',
    cor: '#CC092F',
    sigla: 'BRD',
    logo: 'img/logos/bradesco.png',
    opcoes: [
      { label: 'Private', valor: 11.70 },
      { label: 'Principal', valor: 11.99 },
      { label: 'Residencial Parceira', valor: 12.30 },
      { label: 'Comercial/Terreno', valor: 13.99 },
    ],
  },
  {
    banco: 'Caixa',
    cor: '#005CA9',
    sigla: 'CXA',
    logo: 'img/logos/caixa.png',
    opcoes: [
      { label: 'Relacionamento', valor: 11.19 },
      { label: 'Balcão', valor: 11.29 },
    ],
  },
  {
    banco: 'Inter',
    cor: '#FF500F',
    sigla: 'ITR',
    logo: 'img/logos/inter.png',
    opcoes: [
      { label: 'Balcão', valor: 12.99 },
    ],
  },
  {
    banco: 'Santander',
    cor: '#EC0000',
    sigla: 'STN',
    logo: 'img/logos/santander.png',
    opcoes: [
      { label: 'Taxa Mínima', valor: 11.69 },
      { label: 'Taxa Máxima', valor: 13.59 },
    ],
  },
  {
    banco: 'Itaú',
    cor: '#FF6600',
    sigla: 'ITU',
    logo: 'img/logos/itau.png',
    opcoes: [
      { label: 'Private e Personnalité 4 a 5', valor: 11.70 },
      { label: 'Personnalité 1 a 3', valor: 12.00 },
      { label: 'Uniclass 4 a 5', valor: 12.30 },
      { label: 'Uniclass 1 a 3', valor: 12.80 },
      { label: 'Conta Comum', valor: 13.45 },
    ],
  },
];

export const SIDEBAR_MENU = [
  {
    section: 'Principal',
    items: [
      { icon: '📊', label: 'Dashboard', path: '/dashboard' },
      { icon: '⚡', label: 'Nova Simulação', path: '/simulador' },
      { icon: '📁', label: 'Simulações Salvas', path: '/simulacoes' },
    ],
  },
  {
    section: 'CRM',
    items: [
      { icon: '👥', label: 'Clientes', path: '/crm?tab=pipeline' },
      // { icon: '🏗️', label: 'Pipeline', path: '/crm?tab=pipeline' },
      { icon: '📋', label: 'Tarefas', path: '/tarefas', soon: true },
    ],
  },
  {
    section: 'Relatórios',
    items: [
      { icon: '📈', label: 'Performance', path: '/performance' },
      { icon: '📄', label: 'PDFs Gerados', path: '/pdfs' },
    ],
  },
  
  {
  section: 'Configurações',
  items: [
    { icon: '⚙️', label: 'Conta', path: '/conta' },
    //{ icon: '🎨', label: 'White Label', path: '/whitelabel' },
    { icon: '👥', label: 'Usuários', path: '/usuarios', permission: 'manageUsers' },
    { icon: '🔌', label: 'Integrações', path: '/integracoes', soon: true },
    
  ],
},
];